
const apiURLBase = "loupecenter";

module.exports = {
    apiURLBase:apiURLBase,
};



// WEBPACK FOOTER //
// ./process/constants.js